import { render, staticRenderFns } from "./AdminSettingPermissionItem.vue?vue&type=template&id=329d407c&scoped=true&"
import script from "./AdminSettingPermissionItem.vue?vue&type=script&lang=js&"
export * from "./AdminSettingPermissionItem.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingPermissionItem.vue?vue&type=style&index=0&id=329d407c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d407c",
  null
  
)

export default component.exports